export default __webpack_public_path__ + "static/media/GHSI Regular Board Minutes 12 January 2022.a307cb33.pdf";